var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassFeatureModal",
    {
      staticClass: "upsell-modal",
      attrs: {
        visible: _vm.showModal,
        title: _vm.getTitle,
        variant: "upsell",
        primaryAction: _vm.getPrimaryAction
      },
      on: {
        "update:visible": function($event) {
          _vm.showModal = $event
        },
        closed: function($event) {
          return _vm.$emit("close")
        }
      },
      scopedSlots: _vm._u([
        {
          key: "header",
          fn: function() {
            return [_c("img", { attrs: { src: _vm.getSource } })]
          },
          proxy: true
        }
      ])
    },
    [_vm._v("\n    " + _vm._s(_vm.getDescription) + "\n")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }